(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["manifeste-approche"] && !Shopify.designMode) return;
  try {
    
  class ManifesteApproche extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.mfa__tab'));
      this.panels = Array.from(this.querySelectorAll('.mfa__panel'));
      this.tabs.forEach((tab) => tab.addEventListener('click', () => this.goTo(parseInt(tab.dataset.goto, 10))));
    }
    goTo(i) {
      this.tabs.forEach((tab, idx) => {
        tab.classList.toggle('is-active', idx === i);
        tab.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });
      this.panels.forEach((panel, idx) => panel.classList.toggle('is-active', idx === i));
    }
  }
  customElements.define('manifeste-approche', ManifesteApproche);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      };
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  }

  customElements.define('localization-form', LocalizationForm);
  
  // Gestion des liens obfusqués
  document.addEventListener('DOMContentLoaded', function() {
    // Fonction pour gérer le clic sur les liens obfusqués
    function handleObfuscatedLink(element, newTab = false) {
      const url = element.getAttribute('data-obf');
      if (url) {
        if (newTab) {
          window.open(url, '_blank');
        } else {
          window.location.href = url;
        }
      }
    }
    
    // Écouteur pour les clics
    document.addEventListener('click', function(event) {
      const obfLink = event.target.closest('.obfuscated-link');
      if (obfLink) {
        event.preventDefault();
        handleObfuscatedLink(obfLink, event.ctrlKey || event.metaKey);
      }
    });
    
    // Écouteur pour les clics molette
    document.addEventListener('auxclick', function(event) {
      if (event.button === 1) { // Clic molette
        const obfLink = event.target.closest('.obfuscated-link');
        if (obfLink) {
          event.preventDefault();
          handleObfuscatedLink(obfLink, true);
        }
      }
    });
    
    // Support clavier (Enter et Espace)
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        const obfLink = event.target.closest('.obfuscated-link');
        if (obfLink) {
          event.preventDefault();
          handleObfuscatedLink(obfLink, event.ctrlKey || event.metaKey);
        }
      }
    });
  });
 
  // Gestion des menus accordéon du footer
  document.querySelectorAll('footer .footer__menu').forEach(menu => {
    const toggle = menu.querySelector('strong');

    // Ajouter la flèche si elle n'existe pas déjà
    if (toggle && !toggle.querySelector('.arrow')) {
      const arrow = document.createElement('span');
      arrow.className = 'arrow';
      arrow.innerHTML = `
        <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 14L8 7.5L1 1" stroke="#0D3B26" stroke-width="1.5"/>
        </svg>
      `;  
      toggle.appendChild(arrow); 
    }

    // Toggle open on click
    if (toggle) {
      toggle.addEventListener('click', () => {
        menu.classList.toggle('open');
      });
    }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-main"]) return;
  try {
    
 
const megaMenus = document.querySelectorAll('.v1-mega-menu-wrapper .mega-menu');

megaMenus.forEach(menu => {
  const triggerText = menu.dataset.triggerText?.trim().toLowerCase();
  if (!triggerText) return;

const headerLinks = [...document.querySelectorAll('header a, .site-header a, .menu-bottom a')].filter(link => !link.closest('.v1-nav--mobile'));
  headerLinks.forEach(link => {
    const linkText = link.textContent.trim().toLowerCase();

    if (linkText === triggerText) {
      // Add arrow indicator
      if (!link.classList.contains('has-mega-menu')) {
        link.classList.add('has-mega-menu');
        link.insertAdjacentHTML('beforeend', `
  <span class="mega-menu-arrow" aria-hidden="true">
<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1L7.5 8L14 1" stroke="#0D3B26" stroke-width="1.5"/>
</svg>
  </span> 
`);
      }

      // Add hover listeners
      link.addEventListener('mouseenter', () => {
        hideAllMegaMenus();
        menu.classList.add('visible');
        document.querySelector('#overlay').classList.add('open');
      });
 
      link.addEventListener('mouseleave', () => {
        setTimeout(() => {
          if (!menu.matches(':hover')) {
            menu.classList.remove('visible');
            document.querySelector('#overlay').classList.remove('open');
          }
        }, 200);
      });
      // L'écouteur d'événement 'click' avec e.preventDefault() a été retiré ici.
      // Le lien déclencheur est maintenant cliquable et naviguera vers son URL href.

      menu.addEventListener('mouseenter', () => {
        menu.classList.add('visible');
        document.querySelector('#overlay').classList.add('open');
      });

      menu.addEventListener('mouseleave', () => {
        menu.classList.remove('visible');
        document.querySelector('#overlay').classList.remove('open');
      });

    }
  });
});

function hideAllMegaMenus() {
  document.querySelectorAll('.mega-menu').forEach(menu => {
    menu.classList.remove('visible');
  });
}
  
  } catch(e) { console.error(e); }
})();
})();
